import apiClient from "./client";

const endpoint = "/apptype/m.fetch_apptype.php";
const submissionEnd = "/submission/m.insert_submission_json.php";
const slotsEndpoint = "/slot/m.fetch_slot.php";
const appointmentEndpoint = "/appointment/m.update_appointment.php";
const lastTwoEndpoint = "/submission/m.fetch_submission.php";
const singleEndpoint = "/submission/m.fetch_single_submission.php";

const getQuestions = (token) => {
  // console.log(token, 'ktoken');
  return apiClient.get(
    endpoint + "?access_token=" + token + "&cache=" + Math.random()
  );
};
const getSlots = (token, search_keyword, appointment_date, slot_day) =>
  apiClient.get(
    slotsEndpoint +
      "?search_by=slot_day&search=true&access_token=" +
      token +
      "&search_keyword=" +
      search_keyword +
      "&appointment_date=" +
      appointment_date +
      "&slot_day=" +
      slot_day +
      "&cache=" +
      Math.random()
  );

const getLastTwo = (token) =>
  apiClient.get(
    lastTwoEndpoint + "?access_token=" + token + "&cache=" + Math.random()
  );

const getSubmission = (record_id, token) =>
  apiClient.get(
    singleEndpoint +
      "?access_token=" +
      token +
      "&record_id=" +
      record_id +
      "&cache=" +
      Math.random()
  );

const submission = (finalData, token) => {
  const data = new FormData();
  const access_token = token;
  // const newData = {};
  // const finalJson = Object.assign({}, finalData);
  // delete finalJson.recommendations;
  // newData.type = finalJson.type;
  // newData.totalPoints = finalJson.totalPoints;
  // delete finalJson.type;
  // delete finalJson.totalPoints;
  // const options = Object.assign({}, finalJson);
  // newData.options = options;
  // console.log(finalData, "ooji");
  // console.log(finalData, 'ljdsko');
  data.append("submission_summary", JSON.stringify(finalData));
  data.append("access_token", access_token);
  return apiClient.post(submissionEnd, data);
};

const insertAppointment = (
  appointment_slot,
  appointment_submission_id,
  appointment_date,
  access_token
) => {
  const data = new FormData();
  data.append("appointment_submission_id", appointment_submission_id);
  data.append("appointment_date", appointment_date);
  data.append("appointment_slot", appointment_slot);
  data.append("access_token", access_token);
  console.log(data, "sl");
  return apiClient.post(appointmentEndpoint, data);
};

export default {
  getQuestions,
  submission,
  getSubmission,
  getSlots,
  insertAppointment,
  getLastTwo,
};
